'use strict';

var MarketGridFilterFactory = function MarketGridFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function MarketGridFilter() {
    DemandFilter.call(this, 'market', 'market-demand-analysis');
    this.registerFilters(injectedFilters);
  }
  MarketGridFilter.constructor = MarketGridFilter;
  MarketGridFilter.prototype = Object.create(DemandFilter.prototype);
  return MarketGridFilter;
};
MarketGridFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketGridFilterFactory;